import { useContext } from 'react';
import { I18nContext } from './I18nProvider.js';
import type { I18nValue } from './I18nProvider.js';

/**
 * The whole i18n context: `t`, the current locale, and how to change it.
 *
 * Throws outside the provider rather than falling back to Danish. A component
 * rendered without it is a wiring mistake, and silently working in one language
 * is exactly how that mistake survives to production.
 */
export function useI18n(): I18nValue {
  const value = useContext(I18nContext);
  if (value === null) {
    throw new Error('useI18n must be used inside <I18nProvider>.');
  }
  return value;
}

/** Just the translate function, which is what nearly every caller wants. */
export function useT(): I18nValue['t'] {
  return useI18n().t;
}
